/** API StaffUser ↔ UI staff fields. */

export function staffFromApi(row) {
  if (!row) return null;
  const roles = Array.isArray(row.roles) ? row.roles : [];
  return {
    id: row.id,
    staffId: row.code ?? '',
    fullName: row.fullName ?? '',
    email: row.email ?? '',
    mobile: row.mobile ?? '',
    roleIds: roles.map((r) => r.code || String(r.id)),
    roleDbIds: roles.map((r) => r.id).filter((id) => id != null),
    roles,
    scopeType: row.scopeType ?? 'all',
    buId: row.businessUnit?.code ?? row.buId ?? '',
    buDbId: row.buId ?? null,
    siteId: row.site?.code ?? row.siteId ?? '',
    siteDbId: row.siteId ?? null,
    active: row.isActive !== false,
    lastLoginAt: row.lastLoginAt ?? null,
    createdAt: row.createdAt ?? null,
    updatedAt: row.updatedAt ?? null,
    welcomeEmailSent: row.welcomeEmailSent,
  };
}

export function staffToApi(ui) {
  if (!ui) return null;
  return {
    fullName: ui.fullName,
    email: ui.email,
    mobile: ui.mobile || null,
    scopeType: ui.scopeType || 'all',
    buId: ui.buDbId ?? null,
    siteId: ui.siteDbId ?? null,
    isActive: ui.active !== false,
    roleIds: ui.roleDbIds || undefined,
    password: ui.password || undefined,
  };
}
